"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronsUpDown, Check, Sparkles, Building2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import type { Organization } from "@/lib/types";
const triggerBaseClass = "flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background justify-start";
interface OrganizationSwitcherProps {
  organizations: Organization[];
  selectedOrganization: Organization | null;
  onSelectOrganization: (org: Organization | null) => void;
  triggerClassName?: string;
}
export function OrganizationSwitcher(t0) {
  const $ = _c(55);
  const {
    organizations,
    selectedOrganization,
    onSelectOrganization,
    triggerClassName
  } = t0;
  const [mounted, setMounted] = useState(false);
  const {
    isMobile,
    setOpenMobile
  } = useSidebar();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isMobile || $[3] !== onSelectOrganization || $[4] !== setOpenMobile) {
    t3 = org => {
      if (isMobile) {
        setOpenMobile(false);
      }
      onSelectOrganization(org);
    };
    $[2] = isMobile;
    $[3] = onSelectOrganization;
    $[4] = setOpenMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSelectOrganization = t3;
  const isChatPlanContext = !selectedOrganization || selectedOrganization.kind === "chat";
  const activeClass = isChatPlanContext ? "" : "bg-accent text-accent-foreground";
  if (!mounted) {
    let t4;
    if ($[6] !== activeClass || $[7] !== triggerClassName) {
      t4 = cn(triggerBaseClass, activeClass, triggerClassName);
      $[6] = activeClass;
      $[7] = triggerClassName;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== isChatPlanContext) {
      t5 = isChatPlanContext ? <Sparkles className="h-4 w-4 flex-shrink-0 text-muted-foreground" /> : <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />;
      $[9] = isChatPlanContext;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const t6 = isChatPlanContext ? "Chat plan" : selectedOrganization.name;
    let t7;
    if ($[11] !== t6) {
      t7 = <span className="truncate">{t6}</span>;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ChevronsUpDown className="ml-auto h-4 w-4 flex-shrink-0 opacity-50" />;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
      t9 = <Button variant="ghost" disabled={true} className={t4}>{t5}{t7}{t8}</Button>;
      $[14] = t4;
      $[15] = t5;
      $[16] = t7;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    return t9;
  }
  let t4;
  if ($[18] !== activeClass || $[19] !== triggerClassName) {
    t4 = cn(triggerBaseClass, activeClass, triggerClassName);
    $[18] = activeClass;
    $[19] = triggerClassName;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== isChatPlanContext) {
    t5 = isChatPlanContext ? <Sparkles className="h-4 w-4 flex-shrink-0 text-muted-foreground" /> : <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />;
    $[21] = isChatPlanContext;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const t6 = isChatPlanContext ? "Chat plan" : selectedOrganization.name;
  let t7;
  if ($[23] !== t6) {
    t7 = <span className="truncate">{t6}</span>;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronsUpDown className="ml-auto h-4 w-4 flex-shrink-0 opacity-50" />;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t7) {
    t9 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className={t4}>{t5}{t7}{t8}</Button></DropdownMenuTrigger>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t7;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== handleSelectOrganization) {
    t10 = () => handleSelectOrganization(null);
    $[30] = handleSelectOrganization;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  let t12;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Sparkles className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" />;
    t12 = <span className="truncate">Chat plan</span>;
    $[32] = t11;
    $[33] = t12;
  } else {
    t11 = $[32];
    t12 = $[33];
  }
  let t13;
  if ($[34] !== isChatPlanContext) {
    t13 = isChatPlanContext ? <Check className="ml-auto h-4 w-4 flex-shrink-0" /> : null;
    $[34] = isChatPlanContext;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t10 || $[37] !== t13) {
    t14 = <DropdownMenuItem onSelect={t10} className="cursor-pointer px-2 py-1.5 text-sm hover:bg-accent focus:bg-accent data-[highlighted]:bg-accent">{t11}{t12}{t13}</DropdownMenuItem>;
    $[36] = t10;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  let t16;
  let t17;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DropdownMenuSeparator className="bg-border" />;
    t16 = <DropdownMenuLabel className="px-2 py-1.5 text-xs font-semibold text-muted-foreground">Organizations</DropdownMenuLabel>;
    t17 = <DropdownMenuSeparator className="bg-border" />;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t15 = $[39];
    t16 = $[40];
    t17 = $[41];
  }
  let t18;
  if ($[42] !== handleSelectOrganization || $[43] !== organizations || $[44] !== selectedOrganization?.id) {
    let t19;
    if ($[46] !== handleSelectOrganization || $[47] !== selectedOrganization?.id) {
      t19 = org_0 => <DropdownMenuItem key={org_0.id} onSelect={() => handleSelectOrganization(org_0)} className="cursor-pointer px-2 py-1.5 text-sm hover:bg-accent focus:bg-accent data-[highlighted]:bg-accent"><Building2 className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" /><span className="truncate">{org_0.name}</span>{selectedOrganization?.id === org_0.id && <Check className="ml-auto h-4 w-4 flex-shrink-0" />}</DropdownMenuItem>;
      $[46] = handleSelectOrganization;
      $[47] = selectedOrganization?.id;
      $[48] = t19;
    } else {
      t19 = $[48];
    }
    t18 = organizations.map(t19);
    $[42] = handleSelectOrganization;
    $[43] = organizations;
    $[44] = selectedOrganization?.id;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[49] !== t14 || $[50] !== t18) {
    t19 = <DropdownMenuContent className="w-60 border-border bg-background text-foreground shadow-xl">{t14}{t15}{t16}{t17}{t18}</DropdownMenuContent>;
    $[49] = t14;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== t19 || $[53] !== t9) {
    t20 = <><DropdownMenu>{t9}{t19}</DropdownMenu></>;
    $[52] = t19;
    $[53] = t9;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
}